exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.zdytab .vuxTab .vux-tab {\n  justify-content: space-between;\n  height: 2rem;\n}\n.zdytab .vuxTab {\n  padding-top: 2rem;\n}", ""]);

// exports
